export default class DomainHelper {
    /**
     * Returns the base domain (e.g. "123inkt.nl" or "123inkt.servername.123dev.nl")
     * @param partsAmount Number of domain parts to include from the end
     */
    public static getBaseDomain(partsAmount: number): string {
        const hostname = window.location.hostname;
        const parts = hostname.split('.');
        if (parts.length <= partsAmount) {
            return hostname;
        }

        return parts.slice(-partsAmount).join('.');
    }
}
